import * as angular from 'angular';
import {IController} from 'angular';

export class ShipperSelectListComponent implements IController {
  accountId: string;
  onChange: Function;

  private shippersRef: any;
  private loadLimit: number;
  private infiniteScroll: any;
  private queryString: any;
  private selectedShipperId: any;

  constructor(private $shippers, private $infiniteScroll, private $log) {
  }

  $onInit() {
    this.selectedShipperId = null;
    this.loadLimit = 20;
    this.shippersRef = this.$shippers();
    this.shippersRef.$query(this.getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.shippersRef, this.loadLimit, {getFullData: true});
  }

  submitQuery(query) {
    this.queryString = query;
    this._reload();
  }

  private _reload() {
    this.shippersRef.$query(this.getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }

  onSelectShipper(shipperId){
    this.onChange({shipperId: shipperId});
    // this.shippersRef.$asyncValues([shipperId]).then( shipper => this.onChange({shipper: shipper}));
  }

  private getQueryPayload() {
    return {
      accountId: this.accountId,
      query: this.queryString,
      limit: this.loadLimit
    };
  }
}

angular
  .module('bringoz.admin.shippers')
  .component('shipperSelectList', {
    bindings: {
      accountId: '<?',
      onChange: '&'
    },
    template: require('./shipper-select-list.html').default,
    controller: ShipperSelectListComponent
  });
